import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { AddStaffRole } from "~pages/Staff/types/staffRole.ts";

export const useAddStaffRole = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<unknown, Error, AddStaffRole>({
    mutationFn: async (body) =>
      await request(`${sport}/o/${organizationId}/roles`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId],
      });
    },
  });
};
